import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import { ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";
@Component({
  selector: "app-favorites",
  templateUrl: "./favorites.component.html",
  styleUrls: ["./favorites.component.scss"],
})
export class FavoritesComponent implements OnInit {
  user: any;
  loader = true;
  @ViewChild('masonryContainer') masonryContainer!: ElementRef;
  gap = 16;
  resizeObserver!: ResizeObserver;
  minItemWidth = 264; // controls how many columns per device

  illusData: any[] = [];
  visibleIllusData: any[] = [];
  pageSize = 16;
  currentPage = 1;
  isLoadingMore = false;
  
  constructor(private dataService: DataService, private title: Title, private router: Router) {}

    getSEOImage(url: string): string {
    return buildSEOImageUrl(url);
  }

  
  ngOnInit(): void {
    this.user = this.dataService.userDetail;
    this.title.setTitle(`Favorites | Illusbook`);
    //console.log("this.user");
    //console.log(this.user);
    if(!this.user || !this.user.id) {
      this.router.navigate(["/"]);
      return;
    }

      // ✅ SOURCE DATA
  this.illusData = [...(this.user.favorites || [])];

  // ✅ INIT LOAD MORE
  this.initIllusLoad();
      this.loader = false;
  }

  get favoritesData() {
  return this.user?.favorites || [];
}

 onImageLoad(index: number, event: Event) {
  const img = event.target as HTMLImageElement;

  const item = this.favoritesData[index];
  if (!item) return;

  item.imageLoad = true;
  item.ratio = img.naturalHeight / img.naturalWidth;

  img.classList.add('loaded');


  this.scheduleMasonry();

requestAnimationFrame(() => {
  item.imageLoad = true;
});
}

ngAfterViewInit() {
  this.scheduleMasonry();

  this.resizeObserver = new ResizeObserver(() => {
    this.scheduleMasonry();
  });

  this.resizeObserver.observe(this.masonryContainer.nativeElement);
}

ngOnDestroy() {
  if (this.resizeObserver) {
    this.resizeObserver.disconnect();
  }
}

scheduleMasonry() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      this.buildMasonry();
    });
  });
}



buildMasonry() {
  const container = this.masonryContainer.nativeElement;
  const items = Array.from(
    container.querySelectorAll('.masonry-item')
  ) as HTMLElement[];

  if (!items.length) return;

  const containerWidth = container.clientWidth - 32; // padding
  let columnCount = Math.floor(
    (containerWidth + this.gap) /
      (this.minItemWidth + this.gap)
  );

  // if (columnCount < 1) columnCount = 1;

   columnCount = Math.max(1, Math.min(columnCount, 5));

   // two columns on mobile view
  if (containerWidth < 480) {
    columnCount = 2;
  }

  const itemWidth =
    (containerWidth - (columnCount - 1) * this.gap) /
    columnCount;

  const colHeights = new Array(columnCount).fill(0);

  items.forEach((item, i) => {
    const data = this.favoritesData[i];
    if(!data) return;
    
    item.style.width = `${itemWidth}px`;

    // calculate height using real image ratio
    const height = data.ratio
      ? itemWidth * data.ratio
      : itemWidth * 0.75;

    // shortest column
    let col = 0;
    for (let j = 1; j < columnCount; j++) {
      if (colHeights[j] < colHeights[col]) col = j;
    }

    const x = col * (itemWidth + this.gap);
    const y = colHeights[col];

    item.style.transform = `translate(${x}px, ${y}px)`;

    colHeights[col] += height + this.gap;
  });

  container.style.height =
    Math.max(...colHeights) + 'px';
}


  initIllusLoad() {
    this.currentPage = 1;
    this.visibleIllusData = this.illusData.slice(0, this.pageSize);
  }

  loadMoreIllus() {
    this.isLoadingMore = true;

    setTimeout(() => {
      this.currentPage++;

      this.visibleIllusData = this.illusData.slice(
        0,
        this.currentPage * this.pageSize
      );

      this.isLoadingMore = false;
    }, 300);
  }

  get hasMoreIllus(): boolean {
    return this.visibleIllusData.length < this.illusData.length;
  }
}
